import React, { FunctionComponent } from 'react'
import { ClinTheme } from '../../../../ClinTheme'
import { ClinText } from '../../../../components/ClinText'
import {
  StyledBanner,
  StyledFileName,
  StyledDocumentNameContainer,
  StyledFileExtension,
  StyledOrderDetailsFileName,
  StyledFileNameContainer,
  StyledClinButtonIcon
} from './DocumentUpload.styles'
import { ClinIconPathName } from '../../../../components/ClinIcon/ClinIcon.paths'
import { ClinSpinner } from '../../../../components/ClinSpinner'
import { HoldDocumentDto } from '../../../../types/swaggerTypes'

export interface IUploadedDetails {
  /** Name of the person who uploaded the file */
  uploadedBy?: string
  /** Date the file was uploaded */
  uploadDate?: string
}

export interface DocumentUploadPromptProps {
  /** Title prompt describing the file that should be uploaded*/
  prompt?: string
  /** More detailed information on the file that should be uploaded */
  documentPrompt?: any
  /** Valid file extensions */
  accept?: string
  /** Name of the selected file */
  fileName?: string | null
  /** Render visually different version */
  isPreOrderVariant?: boolean
}

interface DocumentUploadProps extends DocumentUploadPromptProps {
  /** Document details from a document which has already been uploaded */
  uploadDetails?: IUploadedDetails | null
  /** Called when remove button is clicked */
  handleClickRemove?: (e: React.MouseEvent<HTMLButtonElement>) => void
  /** Whether the file is being removed */
  isRemoving?: boolean
  removingDocumentId?: number | undefined
  /** Whether to show the remove button */
  showRemoveFile?: boolean
  /** Error message */
  error?: string | null
  document?: HoldDocumentDto
}

export const DocumentUpload: FunctionComponent<DocumentUploadProps> = ({
  prompt,
  fileName,
  showRemoveFile,
  handleClickRemove,
  document,
  removingDocumentId
}) => {
  return (
    <>
      {fileName && (
        <StyledBanner>
          <div
            style={{
              display: 'flex',
              width: '100%',
              gap: '16px'
            }}
          >
            {showRemoveFile &&
              (removingDocumentId &&
              removingDocumentId === document?.documentId ? (
                <div style={{ padding: '2px 4px' }}>
                  <ClinSpinner />
                </div>
              ) : (
                <StyledClinButtonIcon
                  iconName={ClinIconPathName.Cross}
                  iconFill={ClinTheme.colors.primary}
                  onClick={handleClickRemove}
                />
              ))}
            <StyledFileNameContainer>
              {prompt && (
                <StyledDocumentNameContainer
                  fontSize={ClinTheme.fontSizes[0]}
                  fontWeight={ClinTheme.fontWeights.medium}
                  color={ClinTheme.colors.primaryMid}
                  lineHeight={'16px'}
                >
                  {prompt}
                </StyledDocumentNameContainer>
              )}
              <StyledOrderDetailsFileName>
                <ClinText
                  fontSize={ClinTheme.fontSizes[1]}
                  fontWeight={ClinTheme.fontWeights.normal}
                  color={ClinTheme.colors.black}
                  lineHeight={'24px'}
                >
                  {fileName && fileName.lastIndexOf('.') !== -1 ? (
                    <>
                      <StyledFileName>
                        {fileName.substring(0, fileName.lastIndexOf('.'))}
                      </StyledFileName>
                      <StyledFileExtension>
                        {fileName.substring(fileName.lastIndexOf('.'))}
                      </StyledFileExtension>
                    </>
                  ) : (
                    fileName
                  )}
                </ClinText>
              </StyledOrderDetailsFileName>
            </StyledFileNameContainer>
          </div>
        </StyledBanner>
      )}
    </>
  )
}
